import { useAppDispatch } from "Hook/hooks";
import { useEffect, useState } from "react";
import { Button, Container, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { loginUser, verifyUser } from "../../Redux/Ducks/userSlice";
import { useSearchParams } from "react-router-dom";
import { setToast } from "../../Redux/Ducks/toastSlice";
import { Helmet } from "react-helmet";

interface IModel {
  email: string;
  otp: string;
}

export default function Verify() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [model, setModel] = useState<IModel>({ email: "", otp: "" });
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let email = searchParams.get("email");
    if (email) {
      onChange("email", email);
    } else {
      navigate("login");
    }
  }, []);

  const handleVerify = () => {
    dispatch(verifyUser(model));
  };

  const onChange = (fieldId: string, value: any) => {
    setModel({ ...model, [fieldId]: value });
  };

  const validateEmail = (email: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const signIn = () => {
    const savedEmail = localStorage.getItem("loginEmail");
    if (!savedEmail || !validateEmail(model.email)) {
      dispatch(
        setToast({
          message: "Invalid email format. Please enter a valid email address.",
          type: "error",
        }),
      );
      return;
    }

    dispatch(loginUser(model));
  };

  return (
    <Container fluid className="login-container">
      <Helmet>
        <title>
          Verify | Foodslift POS — Enter the code sent to your inbox
        </title>
        <meta
          name="description"
          content="Verify your Foodslift POS login by entering the code sent to your inbox."
        />
      </Helmet>
      <div className="bg-wrapper" />

      <div className="login-card">
        <div className="login-logo">
          <img
            src="/01-login-page-logo.png"
            alt="FoodsLift"
            className="rounded"
          />
        </div>

        <div className="login-text">
          <h2>Verify your email</h2>
          <p>
            Enter the code sent to{" "}
            <strong>{model.email || "your inbox"}</strong>
          </p>
        </div>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleVerify();
          }}
          className="login-form"
        >
          <Form.Group className="mb-3">
            <Form.Label>Verification code</Form.Label>
            <Form.Control
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder="Enter OTP"
              value={model.otp}
              onChange={(e) => onChange("otp", e.target.value)}
            />
          </Form.Group>

          <Button variant="primary" type="submit" className="login-btn">
            Verify
          </Button>

          <div className="mx-auto w-full text-center">
            <Button
              variant="link"
              type="button"
              onClick={signIn}
              className="login-link-btn text-center"
            >
              Resend OTP
            </Button>
          </div>
        </Form>
      </div>

      <div className="footer">© 2026 Foodslift. All rights reserved.</div>
    </Container>
  );
}
